module.exports = __webpack_public_path__ + "img/themify.9c8e96ec.svg";